export const noop = () => {};

export function addressHasNumber(address) {
  if (!address) {
    return false;
  }

  if (typeof address === 'string') {
    return address.match(/, \d/);
  }

  return address.addressComponents.some(
    component => component.types[0] === 'street_number'
  );
}
